module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iframe-container"
  }, [_c('iframe', {
    ref: "subAppIframe",
    staticClass: "iframe-page",
    attrs: {
      "src": _vm.iframeSrc,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768bffc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/IframePage.vue
// module id = 1130
// module chunks = 1